import React from "react";
import type { IconProps } from "./types";

export const CodePenIcon = React.forwardRef<SVGSVGElement, IconProps>(
  function CodePenIcon(
    {
      size = 24,
      width,
      height,
      className = "",
      fill = "currentColor",
      ...props
    },
    ref
  ) {
    return (
      <svg
        ref={ref}
        width={width || size}
        height={height || size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M12 2L3 7.5V16.5L12 22L21 16.5V7.5L12 2ZM12 4.15L18.85 8.5L16.05 10.4L12 7.65L7.95 10.4L5.15 8.5L12 4.15ZM5 9.8L7 11.15V14.85L5 13.5V9.8ZM19 9.8V13.5L17 14.85V11.15L19 9.8ZM8.95 13.6L12 16.35L15.05 13.6L17.85 15.5L12 19.85L6.15 15.5L8.95 13.6Z"
          fill={fill}
        />
      </svg>
    );
  }
);
